let szenedata = 3;
import { sitePos } from "./sitepos";

sitePos(szenedata);